import { Box, Grid } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const slides = [
    { id: 1, src: "/partner/78win.webp", alt: "78win Promo", link: "https://787888j.com/" },
    { id: 2, src: "/partner/new88.webp", alt: "NEW88 Promo", link: "https://new88-6c7.pages.dev/" },
    { id: 3, src: "/partner/mb66.webp", alt: "MB66 Promo", link: "https://mb66th.pages.dev/" },
    { id: 4, src: "/partner/th39.webp", alt: "TH39 Promo", link: "https://th39.pages.dev/" },
    { id: 5, src: "/partner/vg98.webp", alt: "VG98 Promo", link: "https://vg98.pages.dev/" },
    { id: 6, src: "/partner/th35.webp", alt: "TH35 Promo", link: "https://th35.pages.dev/" },
];

const PromoSlider: React.FC = () => {
    return (
        <>
            {/* ✅ Desktop / PC */}
            <Box
                sx={{
                    width: "100%",
                    maxWidth: 1280,
                    mx: "auto",
                    py: 4,
                    position: "relative",
                    display: { xs: "none", md: "block" }
                }}
            >
                <Swiper
                    modules={[Navigation, Autoplay]}
                    navigation={{
                        nextEl: ".custom-next",
                        prevEl: ".custom-prev",
                    }}
                    autoplay={{ delay: 4000, disableOnInteraction: false }}
                    spaceBetween={25}
                    slidesPerView={1}
                    breakpoints={{
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                    }}
                    style={{ paddingBottom: "0px" }}
                >
                    {slides.map((slide) => (
                        <SwiperSlide key={slide.id}>
                            <a
                                href={slide.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: "none" }}
                            >
                                <Box
                                    component="img"
                                    src={slide.src}
                                    alt={slide.alt}
                                    draggable="false"
                                    sx={{
                                        width: "100%",
                                        //borderRadius: "18px",
                                        //boxShadow:  "0 8px 20px rgba(0,0,0,0.15), 0 0 0 4px rgba(255,255,255,0.4)",
                                        transition: "transform 0.3s ease-in-out, box-shadow 0.3s",
                                        "&:hover": {
                                            transform: "scale(1.03)",
                                           // boxShadow: "0 10px 25px rgba(0,0,0,0.25), 0 0 0 4px rgba(255,150,0,0.6)",
                                            cursor: "pointer",
                                        },
                                    }}
                                />
                            </a>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* ✅ Custom Navigation Buttons */}
                <Box
                    className="custom-prev"
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: -40,
                        transform: "translateY(-50%)",
                        width: 25,
                        height: 25,
                        borderRadius: "50%",
                        backgroundColor: "#fff",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                        color: "#F97316", // สีส้ม
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        zIndex: 10,
                        "&::after": {
                            content: "'‹'",
                            fontSize: "22px",
                            fontWeight: 900,
                            lineHeight: 1,
                            display: "block",
                            transform: "translateX(0px) translateY(-4px)", // ✅ ดันให้อยู่กลางพอดี
                        },
                        "&:hover": {
                            backgroundColor: "#F97316",
                            color: "#fff",
                            boxShadow: "0 0 15px rgba(255,140,0,0.6)",
                        },
                    }}
                />
                <Box
                    className="custom-next"
                    sx={{
                        position: "absolute",
                        top: "50%",
                        right: -40,
                        transform: "translateY(-50%)",
                        width: 25,
                        height: 25,
                        borderRadius: "50%",
                        backgroundColor: "#fff",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                        color: "#F97316",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        zIndex: 10,
                        "&::after": {
                            content: "'›'",
                            fontSize: "22px",
                            fontWeight: 900,
                            lineHeight: 1,
                            display: "block",
                            transform: "translateX(0px) translateY(-4px)", // ✅ ดันให้อยู่กลางพอดี
                        },
                        "&:hover": {
                            backgroundColor: "#F97316",
                            color: "#fff",
                            boxShadow: "0 0 15px rgba(255,140,0,0.6)",
                        },
                    }}
                />
            </Box>
            {/* ✅ Mobile / Tablet — grid 12/12 */}
            <Box
                sx={{
                    display: { xs: "block", md: "none" },
                    px: 2,
                    py: 3,
                }}
            >
                <Grid container spacing={2}>
                    {slides.map((slide) => (
                        <Grid size={{xs: 12}} key={slide.id}>
                            <a
                                href={slide.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: "none" }}
                            >
                                <Box
                                    component="img"
                                    src={slide.src}
                                    alt={slide.alt}
                                    draggable="false"
                                    sx={{
                                        width: "100%",
                                        borderRadius: "14px",
                                        boxShadow:
                                            "0 6px 15px rgba(0,0,0,0.1), 0 0 0 3px rgba(255,255,255,0.3)",
                                    }}
                                />
                            </a>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </>
    );
};

export default PromoSlider;
